
 export class RadicadosPorFecha {
    id: number;
    sede_nombre?: any;
    radicado: string;
    fecha_radicado: Date;
    tipo_documento?: any;
    documento: number;
}

export class ObjectDates {
    fecha_inicio: string;
    fecha_fin: string;
}

export class ObjectDatesRadication {
    fecha_inicio: string;
    fecha_fin: string;
    radicado?: string;
}

export class Answer {
    documento_respuesta: number;
    tarea: number;
}

export interface AnswerTable {
    id: number;
    sede_nombre?: any;
    radicado: string;
    documento: number;
    documento_respuesta: number;
    tarea: number;
    fecha: String;
}

export class InformacionTramiteDefault {
    id_tramite: number;
    nombre_tramite: string;
    id_proceso: number;
    nombre_proceso: string;
    id_categoria: number;
    nombre_categoria: string;
}

export class TramitSelectorFiel {
    id: number;
    nombre: string;
    alias: string;
    data?: any;
    selector?: any;
}

export class DynamicSelector {
    id: number;
    nombre: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/utils.model.ts